import { Container, Link, Text, FileIcon, LinkIcon, YoutubeIcon } from "./_badgeStyle";

const icon = (type: any) => {
  switch (type) {
    case "file":
      return <FileIcon />;
    case "link":
      return <LinkIcon />;
    case "youtube":
      return <YoutubeIcon />;
    default:
      return null;
  }
};

type Props = {
  type?: "file" | "youtube" | "link";
  isLink?: boolean;
  url?: string;
  text?: string;
  newTab?: boolean;
};

function Badge(props: Props) {
  const { type, isLink, text, url, newTab, ...rest } = props;

  return (
    <Container {...rest}>
      {icon(type)}
      {isLink ? (
        <Link href={url} target={newTab ? "_blank" : ""}>
          {text}
        </Link>
      ) : (
        <Text>{text}</Text>
      )}
    </Container>
  );
}

export default Badge;

Badge.defaultProps = {
  type: "file",
  isLink: false,
  url: "",
  text: "",
  newTab: false,
};
